// extracted by mini-css-extract-plugin
export default {"date-break":"DateLineBreak_date-break__lPt2X","hr":"DateLineBreak_hr__l4Nz2"};